<template>
  <v-dialog
    v-model="dialog"
    max-width="85vw"

    min-width="200px"
    
    scrollable 
    persistent
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn small  v-bind="attrs" v-on="on"> Importar Autos</v-btn> 
    </template>
    <v-card min-width="100%">
     
        <v-toolbar dense flat dark color="primary" class="mb-0">
          <v-toolbar-title class="body-2">{{ formTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
          <v-btn x-small icon @click="close">
            <v-icon>fa fa-close</v-icon>
          </v-btn>
          </v-toolbar-items>
        </v-toolbar>


      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col
              cols="12"
              md=3
            >
              <v-text-field 
                filled
                dense
                v-model="codigo"            
                :label="codigo.length>0 ?  'Código' : ''"
                placeholder="Ingrese un código..."
                @keyup.enter="search"
                append-outer-icon="fa fa-search"
                @click:append-outer="search"
                class="body-2"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                dense
                :headers="headers"
                :items="items"
                class="elevation-2"
                :hide-default-header="false"
                min-height="200px"
                height="300px"
                :fixed-header="true"
                :items-per-page="999"
                hide-default-footer
                :disable-pagination='false'
                :loading="loadGrid"
              
                :mobile-breakpoint=100
              >


                <template v-slot:item="{item,headers} ">
                  <tr >
                    <template v-for="(h, idx) in headers" >
                      <td v-if="h.value!='actions'" :align="h.align" :key="idx" :class="['caption', h.class]" v-text="item[h.value]" />
                    </template> 
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="close"
        >
          Cerrar
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="save"
          :disabled="items.length==0"
        >
          Importar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 'ImportAutos',
    props:['formTitle'],

    components: {
      
    },

    data: () => ({
      loadGrid:false,
      dialog:false,
      codigo:"",

      headers: [
        { text: 'Marca',align: 'start',sortable: true, value: 'marca_text' },
        { text: 'Modelo' ,align: 'start',sortable: true, value: 'modelo_text'},
        { text: 'Obs' ,align: 'start',sortable: true, value: 'obs'},
        { text: 'Eje', align:'start',sortable:true,value:'eje_text'},
        { text: 'F. Desde' ,align: 'start',sortable: false, value: 'fDesde'},
        { text: 'F. Hasta' ,align: 'start',sortable: false, value: 'fHasta'},
      ],
      items:[],

    }),
    created: function () {
      console.log("Componente creado")
    },
    mounted: function () {
      console.log("Componente mondado")
    },
    watch: {
    },

    methods: {
      close () {
        this.dialog=false
      },

      save () {
        this.$emit('import', this.items)

        this.close()
      },

      async search (){
        console.log("Buscar datos")

        if (this.codigo.length==0) return

        //console.log(this.codigo.length)

        let response
        let opt

        opt={
          method: 'GET', 
          mode: 'cors'
        }
        response = await fetch(`${this.ROOT_API}cms/autos/${this.codigo}`, opt)

        console.log("response->", response)



        if (response.ok){
          let r=await response.json()

          this.items=r.map(a => {
            return {
              id:0,
              marca_value:a.marcaID,
              marca_text:a.marca,
              modelo_value:a.modeloID,
              modelo_text:a.modelo,
              fDesde:a.f_desde,
              fHasta:a.f_hasta,
              eje_value:a.ejeID,
              eje_text:a.eje,
              obs:a.texto,
              accion:"I"
            }
          })
          //console.log(this.items)
        }

      }


    },
    computed: {
      ...mapGetters(['ROOT_API']),
    },
  }
</script>

<style scoped>

</style>
